import { render } from "./AsyncItemsLoader.vue?vue&type=template&id=dbdca49c&ts=true"
import script from "./AsyncItemsLoader.vue?vue&type=script&lang=ts"
export * from "./AsyncItemsLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__